module.exports = __webpack_public_path__ + "static/media/logo-theme2019.e22e2a43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-theme2019.svg
// module id = 1050
// module chunks = 0